export const subBranchesNames = {
    1 : { 1: "Protecção Família", 2 : "Protecção Acidentes"},
    2 : { 1: "Novo seguro", 2 : "Transferir Seguro"},
  };

  export const branchesNames = {
    1 :  "Vida Protecção",
    2 :  "Vida Crédito",
    3 :  "Multirrisco Habitação"
  };